export const Logo = ({ size = "md", showCaption = true, className = "" }) => {
  const sizes = {
    sm: "text-xl",
    md: "text-[26px]",
    lg: "text-3xl",
  };
  return (
    <span className={`inline-flex flex-col items-center leading-none select-none ${className}`}>
      <span className="inline-block">
        <span className={`block text-center font-display font-extrabold tracking-tight text-white ${sizes[size]}`}>
          Hurtler
        </span>
        <span className="block mt-1.5 h-[3px] w-full rounded-full bg-[#F59E0B]" />
      </span>
      {showCaption && (
        <span className="mt-1.5 text-[8px] font-semibold uppercase tracking-[0.22em] text-white/50">
          Environmental
        </span>
      )}
    </span>
  );
};
